import React from 'react';
import Dropzone from 'react-dropzone';
// // import { Form } from 'elements';
// import { Field } from 'redux-form';
// import PropTypes from 'prop-types';

/**
 * file field that supported dnd
 */
export default class FileField extends React.Component {

    handleDropOrClick = (acceptedFiles, rejectedFiles, e) => {
        let eventOrValue = e;
        let {input: {onChange, onBlur}} = this.props;
        // console.log("asdasd"+e);
        // if (e.type === 'drop') {
            console.log(acceptedFiles);
            if (acceptedFiles.length > 0) {
                // FileList or [File]
                console.log('bl2 ');
                eventOrValue = (e.dataTransfer && e.dataTransfer.files) || acceptedFiles;
        //     } else {
        //         console.log('bl3');
        //         eventOrValue = null;
        //     }
        }
        onBlur(eventOrValue); // update touched
        onChange(eventOrValue); // update value
    }


    render() {
        let {input,
            // meta: {
            // touched,
            // error
        // }
    } = this.props;
        let {accept, multiple} = this.props;
        let selectedFile = (input && input.value && input.value[0]) || null;
        let dropzoneProps = {
            accept,

            multiple,
            onDrop: this.handleDropOrClick,
    };
        return (
            <div className='input-field'>
                <label htmlFor="">Adjuntar CV</label>

                {/*<input type='hidden' disabled {...input} />*/}
                {selectedFile? <span>{selectedFile.name}</span> : null}
                <Dropzone  {...dropzoneProps} > <p className="dict-message">Arrastre aqui su CV o haga click para subir</p></Dropzone>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/FileField.js